import React from 'react';
import { connect } from 'react-redux';
import Mixpanel from 'helpers/Mixpanel.js';
import ListFilter from '@bit/knotchinc.web-react-components.list-filter';
import { SAVE_RICH_PUBLISHER_DATA, SAVE_RICH_BRAND_DATA } from 'components/Global/Filters/actions.js';
import EntityFilterItem from './EntityFilterItem.jsx';

export class EntityFilter extends React.Component {
  itemFiltering(item) {
    const { type, setFilters, selectedItems, richData, setRichData } = this.props;
    const entityId = item.public_id;
    let newCategories;
    let newRichData;
    if (selectedItems.includes(entityId)) {
      Mixpanel.track(`removed ${type} filter`, { filter: item.name });
      newCategories = selectedItems.filter(selectedItem => selectedItem !== entityId);
      newRichData = richData.filter(({ public_id }) => public_id !== entityId);
    } else {
      Mixpanel.track(`added ${type} filter`, { filter: item.name });
      newCategories = selectedItems.concat(entityId);
      newRichData = richData.concat(item);
    }
    setRichData(newRichData);
    setFilters({ [type]: newCategories, pageNum: 1 }, this.props.filterAction);
  }

  render() {
    const { title, type, items, fetch, selectedItems, listAction } = this.props;
    return (
      <ListFilter
        showSearch
        title={title || type}
        fetch={clear => fetch(clear)}
        listStore={items}
        filterAction={listAction}
        searchBy="name"
      >
        <EntityFilterItem
          onClick={item => this.itemFiltering(item)}
          selectedItems={selectedItems}
          showLogo
        />
      </ListFilter>);
  }
}

const mapStateToProps = ({ PublishersList: { richPublisherData }, BrandsList: { richBrandData } }, { type: entityType }) => ({
  richData: entityType.split('_')[0] === 'brand' ? richBrandData : richPublisherData,
});

const mapDispatchToProps = (dispatch, { type: entityType }) => ({
  setFilters: (filters, type) => dispatch({ type, filters }),
  setRichData: data => entityType.split('_')[0] === 'brand'
    ? dispatch({ type: SAVE_RICH_BRAND_DATA, data })
    : dispatch({ type: SAVE_RICH_PUBLISHER_DATA, data }),
});

EntityFilter.defaultProps = {
  selectedItems: [],
};

export default connect(mapStateToProps, mapDispatchToProps)(EntityFilter);
